import Vue from 'vue'
import VueRouter from 'vue-router'
import Unloading from '@/views/Unloading.vue'
import UnloadingPhoto from '@/views/UnloadingPhoto.vue'
import UnloadingPhotos from '@/views/UnloadingPhotos.vue'
import Loading from '@/views/Loading.vue'
import LoadingPhoto from '@/views/LoadingPhoto.vue'
import LoadingPhotos from '@/views/LoadingPhotos.vue'
import Empty from '@/views/Empty.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'empty',
        component: Empty
    },{
        path: '/rozladunek/:token',
        name: 'unloading',
        component: Unloading
    }, {
        path: '/rozladunek/zdjecia/:token',
        name: 'unloading-photos',
        component: UnloadingPhotos
    }, {
        path: '/rozladunek/zdjecie/:token',
        name: 'unloading-photo',
        component: UnloadingPhoto
    },{
        path: '/zaladunek/zdjecia/:token',
        name: 'loading-photos',
        component: LoadingPhotos
    }, {
        path: '/zaladunek/zdjecie/:token',
        name: 'loading-photo',
        component: LoadingPhoto
    }, {
        path: '/:token',
        name: 'loading',
        component: Loading
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    next()
    // scroll to top
    window.scrollTo(0, 0)
})

export default router
